@import '../../../globals/main.scss';
@import './pn-product-card-common.scss';

pn-product-card {
  border: 0.1rem solid $gray200;
  outline: none;
  background: $white;
  box-shadow:
    0px 0.6px 1.8px rgba(0, 0, 0, 0.1),
    0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
  display: flex;
  word-break: break-word;
  text-decoration: none;
  border-radius: 0.8rem;
  position: relative;
  padding: 11rem 2.4rem 2.4rem;
  margin-bottom: 1.6rem;
  @media screen and (min-width: $productcard-media-oversmallmobile) {
    padding: 2.4rem;
  }

  [slot='title'] {
    display: flex;
    width: 100%;
    margin-bottom: 0.8rem;
    gap: 1.6rem;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $productcard-media-oversmallmobile) {
      flex-direction: row;
      align-items: inherit;
    }
    h2 {
      width: 100%;
      @media screen and (min-width: $productcard-media-oversmallmobile) {
        width: auto;
      }

      > a {
        color: $black;
        &::after {
          content: '' !important;
        }
      }
    }
  }

  [slot='note'] {
    margin-top: 1em;
    margin-bottom: 1em;
    font-size: 0.8em;
  }

  [slot='additionalUSP'] {
    display: flex;

    :first-child {
      margin-left: 0em;
    }

    span {
      margin-left: 1em;
      background: $gray200;
      color: $gray900;
      border-radius: 0.25em;
      width: fit-content;
      padding: 0.3em;
      margin-top: 0.5em;
      font-size: 0.75em;
    }
  }

  > pn-illustration {
    min-width: 8rem;
    width: 8rem;
    height: 8rem;
    align-self: center;
    position: absolute;
    top: 1.6rem;
    transform: translateX(-50%);
    left: 50%;
    box-shadow:
      0px 0.6px 1.8px rgba(0, 0, 0, 0.1),
      0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
    border-radius: 100%;
    @media screen and (min-width: $productcard-media-oversmallmobile) {
      box-shadow: none;
      top: 1.6rem;
      right: 1.6rem;
      left: auto;
      transform: none;
    }
    @media screen and (min-width: $productcard-media-tablet) {
      position: static;
      top: auto;
      right: auto;
      margin-right: 3rem;
    }
  }

  .cardcontent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    @media screen and (min-width: $productcard-media-tablet) {
      flex-direction: row;
      gap: 1.6rem;
    }
  }

  [slot='cardprice'] {
    display: flex;
    // flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    padding: 0.6em;
    flex-grow: 1;

    @media screen and (min-width: $productcard-media-oversmallmobile) {
      flex-direction: row;
      justify-content: space-between;
    }

    @media screen and (min-width: $productcard-media-tablet) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
    }
  }

  [slot='mobiledownload'] {
    margin-top: 1rem;
    white-space: nowrap;
    text-align: center;

    display: flex;
    flex-direction: column;

    #riktiga {
      order: 4;
      margin-top: 1em;

      > div {
        > a {
          &::after {
            content: '' !important;
          }
        }
      }
    }
    .riktigaAndroidImg {
      width: 6em;
      margin: 0.5em;
    }

    .riktigaAppleImg {
      width: 5.6em;
      margin: 0.5em;
    }

    a {
      text-decoration: none;
      color: $blue700;
      h3 {
        text-decoration: underline;
      }
    }
  }
  [slot='servicepoint'] {
    // flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    flex-grow: 2;
    align-items: flex-end;
    text-align: center;

    @media screen and (min-width: $productcard-media-oversmallmobile) {
      flex-direction: row;
      justify-content: space-between;
    }

    @media screen and (min-width: $productcard-media-tablet) {
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  .info {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    flex-flow: wrap;

    > * {
      min-width: 6em;
      margin: 0.5em 1em 0.5em 0;
    }

    padding: 0 1em 0 0;
  }
}
